<template lang="pug">
  b-modal#editProviderRtp(
  ref="editProviderRtp"
  :title="$t('ui.combine.edit_provider_rtp')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown")
    b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
      b-form-group(:label="$t('ui.provider_code')" disabled).mb-0
        DebounceInput(
          size="sm"
          ref="provider_code"
          required
          type="text"
          :dirty="$v.provider_code.$dirty"
          :error="$v.provider_code.$error"
          v-model.trim.lazy="$v.provider_code.$model"
          :disabled="loading"
        )
        ValidateResult(:value="$v.provider_code" :name="$t('ui.provider_code')")
      b-form-group(:label="$t('ui.provider_name')" disabled).mb-0
        DebounceInput(
          size="sm"
          ref="provider_name"
          required
          type="text"
          :dirty="$v.provider_name.$dirty"
          :error="$v.provider_name.$error"
          v-model.trim.lazy="$v.provider_name.$model"
          :disabled="loading"
        )
        ValidateResult(:value="$v.provider_name" :name="$t('ui.provider_name')")
      b-form-group(:label="$t('ui.rtp')").mb-0
        DebounceInput(
          size="sm"
          ref="rtp"
          required
          type="text"
          :dirty="$v.rtp.$dirty"
          :error="$v.rtp.$error"
          v-model.trim.lazy="$v.rtp.$model"
          :disabled="loading"
        )
        ValidateResult(:value="$v.rtp" :name="$t('ui.rtp')")
      div.row
        div.col
          b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
    div(slot="modal-cancel")
      SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, requiredIf, alphaNum, minLength, maxLength, integer, numeric, helpers, decimal, minValue, maxValue } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
const alphaNumWithSpace = helpers.regex("alphaNumWithSpace", /^[a-z\d\-_\s]+$/i);

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput
  },
  props: {
    item: {
      type: Object
    },
  },
  data() {
    return {
      provider_code: "",
      provider_name: "",
      rtp: "",
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  computed: {
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID;
    },
  },
  validations: {
    provider_code: {
      required,
      maxLength: maxLength(20)
    },
    provider_name: {
      required,
      maxLength: maxLength(20)
    },
    rtp: {
      required,
      decimal
    },
  },
  methods: {
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.providerRtpEditUrl();

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.operatorID,
          provider_code: this.provider_code,
          rtp: this.rtp,
        };

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.$emit("clicked");
                  this.$refs.editProviderRtp.hide();
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "edit_provider_rtp", this.feedback.status);
                  this.$refs.editProviderRtp.hide();
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    reset: function() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.provider_code = this.item.provider_code;
      this.provider_name = this.item.provider_name;
      this.rtp = this.item.rtp;
      this.$refs.rtp.$el.focus();
    }
  }
};
</script>
